<template>
  <Testimonials
    :title="title"
    :subtitle="subtitle"
    :testimonials="testimonials"
    :alternative-layout="alternativeLayout"
  />
</template>

<script>
import Testimonials from '@/components/Common/Testimonials';

export default {
  components: {
    Testimonials
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      testimonials: [],
      alternativeLayout: false,
      title: '',
      subtitle: ''
    };
  },
  created() {
    const testimonials = this.slice.items;
    this.alternativeLayout = this.slice.slice_label === 'layout_2';
    const title = this.slice.primary.title1[0]?.text;
    this.title = title ? title : '';
    this.subtitle = this.slice.primary.subtitle;

    testimonials.forEach((el) => {
      if (el.testimony[0]?.text) {
        const testimonial = {
          testimony: el.testimony,
          name: el.name && el.name[0]?.text,
          site: el.site && el.site[0]?.text,
          photo: el.photo?.url
        };

        this.testimonials.push(testimonial);
      }
    });
  }
};
</script>
